<div class="container main-container">
  <form novalidate (ngSubmit)="editarQuestao()" [formGroup]="editarQuestaoForm">
    <div class="form-group">
      <input class="form-control" id="titulo" type="text" disabled formControlName="titulo" />
    </div>
    <div class="form-group">
      <p [innerHtml]="questao?.texto"></p>
    </div>

    <p [innerHtml]="questao?.explicacaoProfessor"></p>
    <hr class="rounded" />
    <div>
      <div class="form-group">
        <label class="col-md-2 control-label">Pesquisar habilidades</label>

        <input class="form-control" [(ngModel)]="textoPesquisaHabilidade" id="textoPesquisaHabilidade" type="text"
          placeholder="Digite pelo codigo ou descricao da habilidade" [ngModelOptions]="{ standalone: true }" />
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="" id="porCodigo" [(ngModel)]="porCodigo"
            [ngModelOptions]="{ standalone: true }" />
          <label class="form-check-label" for="flexCheckDefault">
            Por codigo
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-10">
          <span>
            <button class="btn btn-success" id="pesquisarHabilidade" type="button" (click)="pesquisarHabilidade()"
              (disabled)="(disabled)">
              Pesquisar
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <label class="col-md-12 control-label">Habilidades</label>
        <jqxListBox #habilidadesListBox [filterable]="false" [selectedIndex]="0"
          (onSelect)="selecionarHabilidade($event)">
        </jqxListBox>
      </div>
      <div class="col-lg-8">
        <div style="overflow: hidden" #ContentPanel></div>
      </div>
    </div>

    <hr class="rounded" />
    <!--SEGMENTOS-->
    <div class="row">
      <div class="col-lg-6">
        <label class="col-md-12 control-label">Segmentos</label>
        <jqxListBox #segmentosListBox [filterable]="true" [selectedIndex]="0" (onSelect)="selecionarSegmento($event)">
        </jqxListBox>
      </div>
      <div class="col-lg-6">
        <label class="col-md-12 control-label">Anos de Escolaridade</label>
        <jqxListBox #anosEscolaridadeListBox [filterable]="true" [selectedIndex]="0"
          (onSelect)="selecionarAnoEscolaridade($event)">
        </jqxListBox>
      </div>
    </div>

    <!--END SEGMENTOS-->
    <hr class="rounded" />
    <!-- AREAS DE CONHECIMENTO-->
    <div class="row">
      <div class="col-lg-6">
        <label class="col-md-12 control-label">Areas de conhecimento</label>
        <jqxListBox #areasConhecimentoListBox [filterable]="true" [selectedIndex]="0"
          (onSelect)="selecionarAreaConhecimento($event)">
        </jqxListBox>
      </div>
      <div class="col-lg-6">
        <label class="col-md-12 control-label">Componente Curricular</label>
        <jqxListBox #componentesCurricularesListBox [filterable]="false" [selectedIndex]="0"
          (onSelect)="selecionarComponenteCurricular($event)">
        </jqxListBox>
      </div>
    </div>
    <hr class="rounded" />
    <div class="col-lg-6">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="active"  formControlName="active" name="active" />
        <label class="form-check-label" for="flexCheckDefault">
         Ativa
        </label>
      </div>
    </div>

    <!-- END AREAS DE CONHECIMENTO-->
    <hr class="rounded" />

    <div class="form-group">
      <div class="col-md-10">
        <button class="btn btn-success" id="salvar" type="submit">
          Salvar
        </button>
      </div>
    </div>
    <hr class="rounded" />
  </form>
</div>